import { useState } from 'react';
import { IconDown, IconUp } from '@ui/src';
import { StepOneBlockWrapperTypes } from './types';

import cn from '../../new-application.module.css';

const StepOneBlockWrapper = ({
  title,
  regulatedCompanyScheme,
  children,
  withMargin,
}: StepOneBlockWrapperTypes) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div
      className={`${cn.stepOneBlockWrapper} ${withMargin ? cn.withMargin : ''}`}
    >
      {regulatedCompanyScheme && (
        <button
          type="button"
          className={cn.stepOneBlockWrapperTitle}
          onClick={() => setExpanded(!expanded)}
        >
          {title}
          {expanded ? <IconUp /> : <IconDown />}
        </button>
      )}

      {expanded && children}
    </div>
  );
};

export default StepOneBlockWrapper;
